import { render } from "./CadastroTipoPessoasView.vue?vue&type=template&id=474e114a&scoped=true"
import script from "./CadastroTipoPessoasView.vue?vue&type=script&lang=js"
export * from "./CadastroTipoPessoasView.vue?vue&type=script&lang=js"

import "./CadastroTipoPessoasView.vue?vue&type=style&index=0&id=474e114a&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474e114a"]])

export default __exports__